export enum PeriodTableColumn {
  CLAVE = 'Clave',
  DESCRIPCION = 'Descripcion',
  NIVEL = 'Nivel',
  SUFIJO_PROGRAMA = 'SufijoPrograma',
  ES_SEMESTRE_EMPRESARIAL = 'EsSemestreEmpresarial',
  STATUS = 'Estatus',
}
